var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"IncludeFonts"},_vm._l((_vm.fonts),function(f){return _c('link',{key:f,attrs:{"href":("https://fonts.googleapis.com/css2?" + f + "&display=swap"),"rel":"stylesheet","type":"text/css"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }